<template>
  <IAmOverlay
    :loading="loadingSearch"
    :spinner-variant="'info'"
  >
    <!-- ANCHOR - HÀNH TRÌNH -->
    <AppCollapse type="card">
      <AppCollapseItem
        title
        isVisible
        classHeader=""
        classBody="p-50"
      >
        <template #header>
          <div :class="`text-airline fw-700 ${isMobileView ? 'font-medium-2' : 'font-medium-3'}`">
            Tìm chuyến bay Class Booking
          </div>
        </template>

        <div>
          <b-row
            class="section_airport m-0 px-25 d-flex-between"
            no-gutters
          >
            <b-col class="px-25 mb-50">
              <b>Điểm đi</b>
              <ResultSearchAirportSelect
                :data-prop.sync="searchData.flights[0].startPoint"
                class="border-secondary rounded"
                :appendToBody="true"
              />
            </b-col>
            <div class="switch_airport mx-lg-50 d-flex-center">
              <b-button
                variant="primary"
                class="btn-icon rounded-circle p-1 border"
                @click="swapHandle"
              >
                <IAmIcon
                  icon="swap"
                  class="d-flex-center text-white"
                  size="18px"
                />
              </b-button>
            </div>
            <b-col class="px-25 mb-50">
              <b>Điểm đến</b>
              <ResultSearchAirportSelect
                :data-prop.sync="searchData.flights[0].endPoint"
                class="border-secondary rounded"
                :appendToBody="true"
                :right="true"
              />
            </b-col>

            <!-- ANCHOR Ngày đi -->
            <b-col class="px-25 mb-50">
              <b>Ngày đi</b>
              <SearchDatePicker
                :date.sync="searchData.flights[0].departDate"
                :config="{ minDate: 'today' }"
                :class="`border-secondary rounded py-25`"
                :flight="[searchData.flights[0].startPoint, searchData.flights[0].endPoint]"
              />
            </b-col>
          </b-row>

          <b-row
            class="mx-0 mt-50 px-25 align-items-center justify-content-around"
            no-gutters
          >
            <!-- ANCHOR Direct flight select -->
            <b-col
              cols="12"
              md="auto"
              class="mb-75 mb-lg-0 px-50 d-flex flex-wrap justify-content-around align-items-center"
            >
              <b-form-checkbox
                id="isDirectFlightOnly"
                v-model="isDirectFlightOnly"
                switch
                class="custom-control-warning"
                @input="val => handleUpdateNumberOfStop(val)"
              >
                <span class="cursor-pointer text-body fw-600">{{ $t('flight.directFlightSelect') }}</span>
              </b-form-checkbox>
            </b-col>

            <!-- ANCHOR permittedCarriers select -->
            <b-col
              cols="12"
              md="auto"
              class="mb-75 mb-lg-0 px-50"
              style="width: 300px;"
            >
              <SearchCarriersSelect
                :carriers.sync="searchData.permittedCarriers"
                class="flex-fill border-secondary rounded py-25 w-100"
              />
            </b-col>

            <!-- ANCHOR isAddNewTab select -->
            <b-col
              cols="12"
              md="auto"
              class="mb-75 mb-lg-0 px-50 d-flex flex-wrap justify-content-around align-items-center"
            >
              <b-form-checkbox
                id="isAddNewTab"
                v-model="isAddNewTab"
                switch
                class="custom-control-warning"
              >
                <span class="cursor-pointer text-body fw-600">Hiển thị kết quả tab mới</span>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row class="mx-0 mt-75 mt-md-1 justify-content-center">
            <b-button
              pill
              class="btn-gradient"
              @click="classBookingSearchHandle"
            >
              Tìm chuyến bay
            </b-button>
          </b-row>
        </div>
      </AppCollapseItem>
    </AppCollapse>
  </IAmOverlay>
</template>

<script>
import {
  BButton,
  BCol,
  BRow,
  BFormCheckbox,
} from 'bootstrap-vue'
import {
  ref,
  // onBeforeUpdate,
} from '@vue/composition-api'
import { isEmpty } from 'lodash-es'

import { convertISODateTime, convertShortTrip } from '@/@core/utils/filter'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BButton,
    BCol,
    BRow,
    BFormCheckbox,

    IAmOverlay: () => import('@/components/IAmOverlay.vue'),
    SearchDatePicker: () => import('@flightv2/search/components/SearchDatePicker.vue'),
    ResultSearchAirportSelect: () => import('@flightv2/search/components/SearchAirportSelect_result.vue'),
    SearchCarriersSelect: () => import('@flightv2/search/components/SearchCarriersSelect.vue'),
    AppCollapse: () => import('@/@core/components/app-collapse/AppCollapse.vue'),
    AppCollapseItem: () => import('@/@core/components/app-collapse/AppCollapseItem.vue'),
  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingProSearch' ")
    // })

    const { loadingSearch, searchClassBooking } = useClassBookingPro()

    const payloadSearch = ref({ ...JSON.parse(localStorage.getItem('searchFlight')) }) // Common search

    const searchData = ref({
      adult: 1,
      child: 0,
      infant: 0,
      airline: 'VN1A',
      currency: 'VND',
      numberOfStop: 99,
      flights: [
        {
          startPoint: payloadSearch.value?.flights?.[0]?.startPoint ?? 'HAN',
          endPoint: payloadSearch.value?.flights?.[0]?.endPoint ?? 'SGN',
          departDate: payloadSearch.value?.flights?.[0]?.departDate ?? new Date().toLocaleDateString('en-CA'),
        },
      ],
      promoCodes: [],
      permittedCarriers: [],
      isBook: true,
      source: 'VN1A',
      type: 'OW',
    })

    const isDirectFlightOnly = ref(false) // need reset
    const isAddNewTab = ref(true) // need reset

    function handleUpdateNumberOfStop(val) {
      if (val === true) {
        searchData.value.numberOfStop = 0
      } else {
        searchData.value.numberOfStop = 99
      }
    }

    function swapHandle() {
      const temp = searchData.value.flights[0].startPoint
      searchData.value.flights[0].startPoint = searchData.value.flights[0].endPoint
      searchData.value.flights[0].endPoint = temp
    }

    function classBookingSearchHandle() {
      const payload = {
        req: searchData.value,
        isGlobalSearch: false,
        isAddNewTab: isAddNewTab.value,
      }
      searchClassBooking(payload)
    }

    return {
      loadingSearch,
      isAddNewTab,
      searchData,
      isDirectFlightOnly,

      isEmpty,
      convertISODateTime,
      convertShortTrip,
      handleUpdateNumberOfStop,
      swapHandle,
      classBookingSearchHandle,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

</style>
